(ns app.bulk.preview-modal
  "Preview modal for the bulk scheduling page, opened by clicking a
   row's preview image: the story as its audience will see it, with
   its time and settings as they are edited, in the view of the agenda's
   preview modal (`app.agenda.preview-modal/post-view`).

   Modal `:params`: the row's `:story.post/eid` (see
   `app.bulk.page/preview-actions`); the row, the account, its Facebook
   pages and highlights come from the page's state."
  (:require [app.agenda.preview-modal :as agenda-preview]
            [app.bulk.page :as page]
            [parts.replicant.query :as query]
            [ui.gallery.entry-modal :as entry-modal]))

(defn fb-page-name
  "The name of the Facebook page that the row shares to."
  [row fb-linkages]
  (some #(when (= (:share-to-fb-id row) (str (:facebook-linkage/id %)))
           (:facebook-linkage/name %))
        fb-linkages))

(defn row->post
  "The row as a story post of the agenda, which `post-view` shows. A
   saved row is scheduled; a new or edited one has no status yet, its
   modal says that the changes are unsaved."
  [row status fb-linkages]
  {:status (when (= :existing status) :scheduled)
   :instagram.story.post/date (page/parse-date-str (:story.post/date-str row))
   :instagram.story.post/highlight-id (:story.post/highlight-id row)
   :instagram.story.post.job/share-to-fb? (:share-to-fb? row)
   :schedule/share-to-fb-name (fb-page-name row fb-linkages)
   :instagram.story.post/ai-generated? (:story.post/ai-generated? row)
   :instagram.story.post/media {:story-media/name (:story.media/name row)}})

(defn user->account
  [user]
  (when user
    {:account/name (:instagram.user/name user)
     :account/profile-picture-url (:instagram.user/profile-picture-url user)}))

(defn action-bar
  "'Close', and a note when the row is not saved yet: the preview shows
   the edit, not what is scheduled."
  [unsaved?]
  [:div.flex.items-center.justify-between.gap-3.border-t.border-gray-200.pt-4
   (when unsaved?
     [:span.rounded-full.bg-amber-50.px-2.text-xs.font-medium.text-amber-700.ring-1.ring-amber-200
      {:class ["py-0.5"]}
      "Unsaved changes"])
   [:div.flex-grow]
   (agenda-preview/close-button)])

(defn render
  [state]
  (let [eid (get-in state [:ui/modal :params :story.post/eid])
        row (page/row-by-eid state eid)
        user (page/selected-user state)
        status (when row (page/pending-status state row))]
    (if-not row
      [:div.flex.flex-col.gap-4
       {:class entry-modal/content-width-class}
       [:p "This story is no longer in the list."]
       [:div.flex.justify-end
        (agenda-preview/close-button)]]
      (agenda-preview/post-view
        {:post (row->post row status (:instagram.user/facebook-linkages user))
         :account (user->account user)
         :highlights (:bulk/highlights
                      (query/get-result state (page/bulk-query state)))
         :media (if (:story.media/preview-url row)
                  (entry-modal/preview
                    {:story-media/preview-url (:story.media/preview-url row)
                     :story-media/video-url (:story.media/video-url row)
                     :story-media/name (:story.media/name row)})
                  (agenda-preview/no-preview-box))
         :now (js/Date.)
         :actions (action-bar (not= :existing status))}))))

(def modal
  {:modal-id :modals/bulk-preview
   :render #'render})
